module.exports = __webpack_public_path__ + "static/media/platinum-1.53b5ba06.png";